<template>
  <el-dialog
    class="rc-dialog"
    title="图书导入"
    :visible.sync="CUFlag"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="45%"
  >
    <el-form
      ref="uForm"
      :model="uploadForm"
      size="small"
      :rules="rules"
      label-position="right"
      label-width="100px"
    >
      <el-form-item
        required
        label="附件："
        error="请上传附件"
        :show-message="uploadForm.file == null"
      >
        <upload v-model="uploadForm.file" ref="removeFile" :size="10" />
      </el-form-item>
      <el-form-item
        label="图书来源："
        prop="bookSource"
        :rules="[{ required: true, message: '请输入图书来源' }]"
      >
        <el-input
          placeholder="请输入图书来源"
          v-model="uploadForm.bookSource"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import vue from "@/main";
import { importBook } from "@/api/book";
import Upload from "@/components/upload/excel";

export default {
  components: { butn, Upload },
  data() {
    return {
      CUFlag: false,
      uploadForm: {
        file: null,
        bookSource: null
      },
      rules: {}
    };
  },
  created() {
  },
  methods: {
    show() {
      this.CUFlag = true;
    },
    createData() {
      if (this.uploadForm.file != null) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.uploadForm.file);
        formData.append("bookSource", this.uploadForm.bookSource);
        this.$refs["uForm"].validate(valid => {
          if (valid) {
            importBook(formData).then(res => {
              this.loading = false;
              if (res && res.code == 0) {
                if (res.data != null) {
                  this.$message.error("导入包含错误数据，请检查");
                  this.$router.push({
                    path: "/excelError"
                  });
                  localStorage.setItem(
                    "errorExcelData",
                    JSON.stringify(res.data)
                  );
                  this.closeDialog();
                } else {
                  this.$message.success(res.msg);
                  this.$emit("initTable");
                  this.closeDialog();
                }
              } else {
                this.$refs.removeFile.$refs.upload.uploadFiles.pop();
                this.uploadForm.file = null;
              }
            });
          }
        });
      }
    },
    closeDialog() {
      this.CUFlag = false;
      // 数据重置
      this.uploadForm.file = null;
      this.uploadForm.bookSource = null;
    }
  },

};
</script>
